// utils
import { getCurrentDate } from "src/utils/dateHelper";

// cache store
import configure from "src/utils/store";

async function fetchSearchEvents(_data) {
  let now = getCurrentDate();

  let data = {
    pageSize: _data?.pageSize || 5,
    pageNumber: _data?.pageNumber || 1,
    latitude: _data?.lat || "36.1251958",
    longitude: _data?.lng || "-115.3150848",
    dateTimeNow: now.prettier.dateTimeNow,
  };

  const api = await configure();

  const response = await api(
    {
      method: "POST",
      url: `/NewSearchEvent`,
      data: data,
      params: data.categoryId,
    },
    { cache: { maxAge: 5 * 60 * 1000 } }
  );

  return response;
}

export { fetchSearchEvents };
